import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=2624122a&"
import script from "./Notes.vue?vue&type=script&lang=ts&"
export * from "./Notes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QEditor,QIcon} from 'quasar'
component.options.components = Object.assign({QEditor,QIcon}, component.options.components || {})
